<template>
  <div>
    <breadcrumbs :home="showUsersRoles!=='1'?'My tasks' : 'Tasks'"/>

    <purtrak-table name="tasks" objectType="tasks" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   :nonPagedItems="tasks" listEndPoint="" fields=""
                   height="calc(100vh - 152px)"
                   @dblclick="item => performTask(item)"
                   title="Tasks"
                   :print-info="{pageSize:'portrait', subTitle:[]}">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.incomplete='1';filters.waiting='0';filters.completed='0';filters.onlyPersonal='0';refresh()">
          <v-list-item class="mt-n5">
            <v-checkbox v-model="filters.incomplete" true-value="1" false-value="0" label="Incomplete" @change="refresh()"/>
          </v-list-item>
          <v-list-item class="mt-n5">
            <v-checkbox v-model="filters.waiting" true-value="1" false-value="0" label="Waiting on other tasks" :disabled="filters.incomplete==='0'" @change="refresh()"/>
          </v-list-item>
          <v-list-item class="mt-n5">
            <v-checkbox v-model="filters.completed" true-value="1" false-value="0" label="Completed" @change="refresh()"/>
          </v-list-item>
          <v-list-item>
            <date-range :disabled="filters.completed=='0'" :from.sync="filters.completedFrom" :to.sync="filters.completedTo" v-model="dateDisplay" @change="refresh()"/>
          </v-list-item>
          <v-list-item class="mt-n5" v-if="showUsersRoles!=='1'">
            <v-checkbox v-model="filters.onlyPersonal" true-value="1" false-value="0" label="Only personal tasks" @change="refresh()"/>
          </v-list-item>
        </filter-menu>
        <div style="width:250px" v-if="showUsersRoles==='1'">
          <multi-level-select hide-details :menuData="usersRoles" :first.sync="userRoleType" :second.sync="userRoleId" @change="refresh()"/>
        </div>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.incomplete=='0'" close small class="ml-1" @click:close="filters.incomplete='1';refresh()">No incomplete</v-chip>
          <v-chip v-show="filters.waiting=='1'" close small class="ml-1" @click:close="filters.waiting='0';refresh()">Waiting</v-chip>
          <v-chip v-show="filters.completed=='1'" close small class="ml-1" @click:close="filters.completed='0';refresh()">Completed {{dateDisplay}}</v-chip>
          <v-chip v-show="showUsersRoles!=='1' && filters.onlyPersonal=='1'" close small class="ml-1" @click:close="filters.onlyPersonal='0';refresh()">Only personal tasks</v-chip>
        </template>
      </template>

      <template v-slot:item.check="{item,printing}">
        <v-icon v-if="!printing && item.completed">mdi-checkbox-outline</v-icon>
      </template>
      <template v-slot:item.description="{item,printing}">
        <template v-if="printing">{{item.description}}</template>
        <template v-else>
          <div :class="{'grey--text':!item.completed && item.dependsOnCount,'red--text':!item.completed && item.startDate < today}">{{item.description}}</div>
          <div v-if="item.completed" class="text-caption"></div>
          <div v-else-if="item.dependsOnCount" class="text-caption">Waiting</div>
          <div v-else-if="item.startDate < today" class="text-caption">Overdue</div>
        </template>
      </template>
      <template v-slot:item.startDate="{value}">
        {{value | formatDate}}
      </template>
      <template v-slot:item.completed="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.personal="{value}">
        {{value ? 'Y' : ''}}
      </template>
      <template v-slot:header.action v-if="showUsersRoles!=='1'">
        <v-btn fab color="primary" small @click="editPersonalTask()"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Task operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <template>
              <v-list-item @click="performTask(item)"><v-list-item-title>Perform task</v-list-item-title></v-list-item>
              <v-list-item v-if="item.primitiveType" @click="printTask(item)"><v-list-item-title>Print work order</v-list-item-title></v-list-item>
              <v-list-item v-if="!item.completed" @click="markAsComplete(item)"><v-list-item-title>Mark as complete</v-list-item-title></v-list-item>
              <v-list-item v-if="item.completed" @click="markAsIncomplete(item)"><v-list-item-title>Mark as incomplete</v-list-item-title></v-list-item>
<!--
              <v-list-item v-if="!item.completed" @click="performTask(item)"><v-list-item-title>Reassign</v-list-item-title></v-list-item>
              -->
              <template v-if="company.allowAudit && company.permissions.includes('audit')">
                <v-divider/>
                <v-list-item :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
              </template>
              <template v-if="item.personal && !item.completed">
                <v-divider/>
                <v-list-item @click="editPersonalTask(item.id)"><v-list-item-title>Edit task</v-list-item-title></v-list-item>
                <v-list-item @click="deleteTask=item;showDelete=true"><v-list-item-title>Delete task</v-list-item-title></v-list-item>
              </template>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <v-dialog v-model="showAdHoc" persistent max-width="400">
      <v-card>
        <v-card-title>{{activity.primitiveType ? 'Mark as complete' : 'Perform activity'}}</v-card-title>
        <v-divider/>
        <v-card-text class="pa-4">
          <v-container>
            <v-row>
              <v-col class="text-h6 mb-4">
                {{activity.description}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8">
                <date-picker v-model="activityComplete" label="Completed"/>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="showAdHoc=false">Cancel</v-btn>
          <v-btn color="primary" @click="completeActivity()" :saving="loading">Complete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showEditPersonalTask" persistent max-width="400">
      <v-card>
        <v-card-title>{{input.id?'Edit':'Add'}} personal task</v-card-title>
        <v-divider/>
        <v-card-text class="pa-4">
          <v-form v-model="valid">
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field label="Description" outlined dense v-model="input.description" :rules="[fieldRules.required,fieldRules.maxLength(100)]" counter="100" autofocus/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8">
                  <date-picker  v-model="input.startDate" label="Start" dateOnly/>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="showEditPersonalTask=false">Cancel</v-btn>
          <v-btn color="primary" @click="doEditPersonalTask()" :saving="loading">{{input.id?'Save':'Add'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <delete-object v-model="showDelete" :name="deleteTask.description" @delete="performDeleteTask"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import productionMashingPrintMash from '@/views/production/mashing/productionMashingPrintMash'
import productionDistillingPrintDistillation from '@/views/production/distilling/productionDistillingPrintDistillation'
import productionBlendingPrintBlend from '@/views/production/blending/productionBlendingPrintBlend'
import productionBottlingPrintBottling from '@/views/production/bottling/productionBottlingPrintBottling'
import productionAssemblyPrintAssembly from '@/views/production/assembly/productionAssemblyPrintAssembly'

export default {
  name: 'PlanningTasks',
  mixins: [productionMashingPrintMash,productionDistillingPrintDistillation,productionBlendingPrintBlend,
           productionBottlingPrintBottling,productionAssemblyPrintAssembly],
  props: {
    showUsersRoles: {type:String,required:false}
  },
  data() {
    return {
      loading: true,
      today: format(new Date(), 'yyyy-MM-dd'),
      filters: {
        incomplete: '1',
        waiting: '0',
        completed: '0',
        completedFrom: null,
        completedTo: null,
        onlyPersonal:false
      },
      usersRoles: [],
      userRoleType: null,
      userRoleId: null,
      dateDisplay: '',
      tasks: [],
      showAdHoc: false,
      activity: {},
      activityComplete: '',
      valid: false,
      showEditPersonalTask: false,
      input: {},
      showDelete: false,
      deleteTask: {},
      defaultColumns: [{ value: 'check', visible:true, excludeFromExport:true},
                       { value: 'description', visible:true},
                       { value: 'personal', visible:true,},
                       { value: 'startDate', visible:true},
                       { value: 'completed', visible:true}],
      headers: [{ text: '', value: 'check', width:'5%',sortable:false},
                { text: 'TASK', value: 'description', width:'40%',sortable:true},
                { text: 'PERSONAL', value: 'personal', width:'10%',sortable:false, align:'center',omit:() => this.showUsersRoles==='1'},
                { text: 'SCHEDULED START', value: 'startDate', width:'20%',sortable:true},
                { text: 'COMPLETED', value: 'completed', width:'20%',sortable:true}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    async showUsersRoles() {
      await this.getUsersRoles();
      await this.refresh();
    }
  },
  async created() {
    if (this.showUsersRoles==='1')
      await this.getUsersRoles();
  },
  methods: {
    async getUsersRoles() {
      const results = await this.$apiCall(`query PlanningTasks {
                                              roles {
                                                id,name
                                              }
                                              company {
                                                users {
                                                  userId,name
                                                }
                                              }
                                            }`, {});
      if (!results.error) {
        const users = results.data.company.users.map(user => ({name:user.name,id:user.userId}));
        this.usersRoles = [{name:'Role',id:'role',menu:results.data.roles},{name:'User',id:'user',menu:users}]
        this.userRoleType = 'user';
        this.userRoleId = users[0].id;
      }
    },
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query PlanningTasks($incomplete:Boolean, $waiting:Boolean, $completedFrom:DateTime, $completedTo:DateTime, $userId:String, $roleId:ID, $onlyPersonal:Boolean, $omitPersonal:Boolean) {
                                              activitiesForUser(incomplete:$incomplete, waiting:$waiting, completedFrom:$completedFrom, completedTo:$completedTo, userId:$userId, roleId:$roleId, onlyPersonal:$onlyPersonal, omitPersonal:$omitPersonal) {
                                                id,primitiveType,primitiveId,description,siteId,siteName,roleName,startDate,quantity
                                                dependsOnCount,completed,personal
                                              }
                                            }`,
                                          {incomplete:this.filters.incomplete==='1', waiting:this.filters.waiting==='1',
                                           completedFrom:this.filters.completed==='1'?this.filters.completedFrom+' 00:00:00':null,
                                           completedTo:this.filters.completed==='1'?this.filters.completedTo+' 23:59:59':null,
                                           onlyPersonal:this.filters.onlyPersonal==='1',
                                           omitPersonal:this.showUsersRoles==='1',
                                           userId:this.showUsersRoles==='1' && this.userRoleType==='user'?this.userRoleId:null,
                                           roleId:this.showUsersRoles==='1' && this.userRoleType==='role'?this.userRoleId:null});
      if (!results.error) {
        this.tasks = results.data.activitiesForUser;
      }
      this.loading = false;
    },
    async printTask(activity) {
      if (activity.completed)
        return;
      switch (activity.primitiveType) {
        case 'MashBill':
          this.printMash(activity.primitiveId, {quantity: activity.quantity, date: activity.startDate, siteName: activity.siteName}, true);
          break;
        case 'Process':
          this.printDistillation(activity.primitiveId, {quantity:activity.quantity, date:activity.startDate, siteName:activity.siteName}, true);
          break;
        case 'Formula':
          this.printBlend(activity.primitiveId, {quantity:activity.quantity, date:activity.startDate, siteName:activity.siteName, performBy:activity.roleName ?? ''}, true);
          break;
        case 'Product':
          this.printBottling(activity.primitiveId, {quantity:activity.quantity, date:activity.startDate, siteName:activity.siteName}, true);
          break;
        case 'Item':
          this.printAssembly(activity.primitiveId, {quantity:activity.quantity, date:activity.startDate, siteName:activity.siteName}, true);
          break;
        default:
          break;
      }
    },
    async performTask(activity) {
      if (activity.dependsOnCount || activity.completed)
        return;
      switch (activity.primitiveType) {
        case 'MashBill':
          this.$router.push({name:'ProductionMashingEditNew',params:{mashBillId:activity.primitiveId,volume:activity.quantity,activityId:activity.id}});
          break;
        case 'Process':
          this.$router.push({name:'ProductionDistillingEditNew',params:{processId:activity.primitiveId,activityId:activity.id}});
          break;
        case 'Formula':
          this.$router.push({name:'ProductionBlendingEditNew',params:{formulaId:activity.primitiveId,volume:activity.quantity,activityId:activity.id}});
          break;
        case 'Product':
          this.$router.push({name:'ProductionBottlingEditNew',params:{productId:activity.primitiveId,cases:activity.quantity,activityId:activity.id}});
          break;
        case 'Item':
          this.$router.push({name:'ProductionAssemblyEditNew',params:{itemId:activity.primitiveId,quantity:activity.quantity,activityId:activity.id}});
          break;
        default:
          this.markAsComplete(activity);
          break;
      }
    },
    async markAsComplete(activity) {
      this.activity = activity;
      this.activityComplete = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      this.showAdHoc = true;
    },
    async completeActivity() {
      this.loading = true;
      const results = await this.$apiCall(`mutation PlanningTasks($id: ID!, $date: DateTime!) {
                                              activityComplete(id:$id, date:$date) {
                                                id,completed
                                              }
                                            }`,
                                          {id:this.activity.id, date:this.activityComplete});
      if (!results.error) {
        this.refresh();   // Must refresh since dependencies might be changed
        this.$store.dispatch('checkTasks', true);
      }
      this.loading = false;
      this.showAdHoc = false;
    },
    async markAsIncomplete(activity) {
      this.loading = true;
      const results = await this.$apiCall(`mutation PlanningTasks($id: ID!) {
                                              activityMarkAsIncomplete(id:$id) {
                                                id,completed
                                              }
                                            }`,
                                          {id:activity.id});
      if (!results.error) {
        this.refresh();   // Must refresh since dependencies might be changed
        this.$store.dispatch('checkTasks', true);
      }
      this.loading = false;
    },
    async editPersonalTask(id) {
      if (id) {
        const results = await this.$apiCall(`query PlanningTasks($id: ID!) {
                                                activity(id:$id) {
                                                  id,description,startDate,assignTo
                                                  duration,color,quantity,dependsOn,equipment,materials{id},hasSubActivities,offsetDays
                                                }
                                              }`,
                                            {id});
        if (!results.error)
          this.input = results.data.activity;
      }
      else
        this.input = {personal:true, description:'',startDate: format(new Date(), 'yyyy-MM-dd'), assignTo:[this.$store.state.user.sub],
                      duration:0, color:'#000', quantity:0, dependsOn:[], equipment:[], materials:[], hasSubActivities:false, offsetDays:0};
      this.showEditPersonalTask = true;
    },
    async doEditPersonalTask() {
      if (!this.valid)
        return;

      this.loading = true;
      const results = await this.$apiCall(`mutation PlanningTasks($input: ActivityInput!) {
                                              ${this.input.id?'activityUpdate':'activityCreate'}(input:$input) {
                                                id
                                              }
                                            }`,
                                          {input:this.input});
      this.loading = false;
      if (!results.error) {
        this.refresh();   // Must refresh since dependencies might be changed
        this.$store.dispatch('checkTasks', true);
        this.showEditPersonalTask = false;
      }
    },
    async performDeleteTask() {
      const results = await this.$apiCall(`mutation PlanningTasks($id: ID!) {
                                              objectDelete(id:$id)
                                            }`,
                                          {id:this.deleteTask.id});
      if (!results.error) {
        this.refresh();   // Must refresh since dependencies might be changed
        this.$store.dispatch('checkTasks', true);
      }
    }
  }
}
</script>